import { Image as DatoImage } from 'react-datocms';
import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { ResponsiveImage } from 'services/graphql';

import ValueCard from './ValueCard';

import styles from './ValuesCloudBlock.module.css';

interface ValuesCloudBlockRecord extends CdaStructuredTextRecord {
  text1: string;
  text2: string;
  text3: string;
  text4: string;
  image: ResponsiveImage;
}

export default function ValuesCloudBlock({ text1, text2, text3, text4, image }: ValuesCloudBlockRecord) {
  const { width, height } = image.responsiveImage;
  const aspectRatio = width / (height ?? width);

  const cards = [
    { text: text1, variant: 'solid' as const, className: styles.firstCard },
    { text: text2, variant: 'gradient' as const },
    { text: text3, variant: 'gradient' as const, className: styles.bottomLeft },
    { text: text4, variant: 'solid' as const, className: styles.bottomRight },
  ];

  return (
    <section
      data-testid="values-block"
      className={styles.container}
    >
      <div className={styles.wrapper}>
        <div className={styles.imageSlot}>
          <div
            className={styles.imageWrapper}
            style={{ aspectRatio }}
          >
            <DatoImage
              data={image.responsiveImage}
              layout="fill"
              objectFit="cover"
              objectPosition="50% 50%"
            />
          </div>
        </div>
        {cards.map(({ text, variant, className }, index) => (
          <ValueCard
            key={index}
            text={text}
            variant={variant}
            className={className}
          />
        ))}
      </div>
    </section>
  );
}
